<template>
<div id="appdashboard" v-cloak>
    <b-card header="Opzioni" class="text-center mx-auto" style="width: 95%;margin-top:15px;">

        <b-container class="bv-example-row">
            <b-row>
                <b-col v-if="ctrlVismenu('T')" style="margin-bottom: 15px;">
                    <router-link to="/app/categorie" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/categorie.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Categorie</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>

<!--                 <b-col v-if="ctrlVismenu('C')" style="margin-bottom: 15px;">
                    <router-link to="/app/convenzioni" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/convenzioni.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Convenzioni</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->

                <b-col v-if="ctrlVismenu('E')" style="margin-bottom: 15px;">
                    <router-link to="/app/eventi" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/eventi.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Eventi</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>

                <b-col v-if="ctrlVismenu('S') || ctrlVismenu('Z')" style="margin-bottom: 15px;">
                    <router-link to="/app/soci" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/soci.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Soci</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>

<!--                 <b-col v-if="ctrlVismenu('P')" style="margin-bottom: 15px;">
                    <router-link to="/app/pagamenti" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/pagamenti.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Pagamenti</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
<!--                 <b-col v-if="ctrlVismenu('O')" style="margin-bottom: 15px;">
                    <router-link to="/app/sconti" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/sconti.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Sconti</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
<!--                 <b-col v-if="ctrlVismenu('D')" style="margin-bottom: 15px;">
                    <router-link to="/app/documenti" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/documenti.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Documenti</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
<!--                 <b-col v-if="ctrlVismenu('I')" style="margin-bottom: 15px;">
                    <router-link to="/app/impianti" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/impianti.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Impianti</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>
                <b-col v-if="ctrlVismenu('A')" style="margin-bottom: 15px;">
                    <router-link to="/app/abbonamenti" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/abbonamenti.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Abbonamenti</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
<!--                 <b-col v-if="ctrlVismenu('Q')" style="margin-bottom: 15px;">
                    <router-link to="/app/questionari" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/quest.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Questionari</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
                <b-col v-if="ctrlVismenu('U')" style="margin-bottom: 15px;">
                    <router-link to="/app/push" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/push.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Push Notification</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>
                <!-- news gestite come eventi -->
<!--                 <b-col v-if="ctrlVismenu('N')" style="margin-bottom: 15px;">
                    <router-link to="/app/news" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/news.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>News</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
                <b-col v-if="ctrlVismenu('B')" style="margin-bottom: 15px;">
                    <router-link to="/app/bacheca" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/bacheca.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Bancarella</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>
                <b-col v-if="ctrlVismenu('L')" style="margin-bottom: 15px;">
                    <router-link to="/app/modulistica" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/modulistica.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Modulistica</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>
<!--                 <b-col v-if="ctrlVismenu('R')" style="margin-bottom: 15px;">
                    <router-link to="/app/prenotazioni" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/prenotazioni.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Prenotazioni</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col> -->
                <b-col v-if="ctrlVismenu('M')" style="margin-bottom: 15px;">
                    <router-link to="/app/parametri" style="text-decoration: none;color: black;">
                        <b-row>
                            <b-col>
                                <b-img :fluid=true center :src="require('../assets/parametri.png')" alt="" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5>Parametri</h5>
                            </b-col>
                        </b-row>
                    </router-link>
                </b-col>



            </b-row>
        </b-container>

    </b-card>

</div>
</template>

<script>


import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdashbord',
    methods: {
        ctrlVismenu(key){
            //sembra ricorsiva ma non lo è, qui sotto viene chiamata la funzione di util.js
            return ctrlVismenu(key);
        }
    },
    data: function () {
        return {};
    }
}
</script>
